import { render, staticRenderFns } from "./ConfigRoleUserChatForPlus.vue?vue&type=template&id=7cdbab4e&scoped=true"
import script from "./ConfigRoleUserChatForPlus.vue?vue&type=script&lang=js"
export * from "./ConfigRoleUserChatForPlus.vue?vue&type=script&lang=js"
import style0 from "./ConfigRoleUserChatForPlus.vue?vue&type=style&index=0&id=7cdbab4e&lang=css"
import style1 from "./ConfigRoleUserChatForPlus.vue?vue&type=style&index=1&id=7cdbab4e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cdbab4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7cdbab4e')) {
      api.createRecord('7cdbab4e', component.options)
    } else {
      api.reload('7cdbab4e', component.options)
    }
    module.hot.accept("./ConfigRoleUserChatForPlus.vue?vue&type=template&id=7cdbab4e&scoped=true", function () {
      api.rerender('7cdbab4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/school/chat/ConfigRoleUserChatForPlus.vue"
export default component.exports